/* eslint-disable max-len */
import 'react';

const MoreSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7309" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="black" />
        </mask>
        <g mask="url(#mask0_38017_7309)">
            <path fillRule="evenodd" clipRule="evenodd" d="M3 9C3 8.37868 3.50368 7.875 4.125 7.875C4.74632 7.875 5.25 8.37868 5.25 9C5.25 9.62132 4.74632 10.125 4.125 10.125C3.50368 10.125 3 9.62132 3 9Z" fill="#39404D" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.875 9C7.875 8.37868 8.37868 7.875 9 7.875C9.62132 7.875 10.125 8.37868 10.125 9C10.125 9.62132 9.62132 10.125 9 10.125C8.37868 10.125 7.875 9.62132 7.875 9Z" fill="#39404D" />
            <path fillRule="evenodd" clipRule="evenodd" d="M12.75 9C12.75 8.37868 13.2537 7.875 13.875 7.875C14.4963 7.875 15 8.37868 15 9C15 9.62132 14.4963 10.125 13.875 10.125C13.2537 10.125 12.75 9.62132 12.75 9Z" fill="#39404D" />
        </g>
    </svg>
);
export default MoreSvg;
